import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApisManagersEmployeeConditionSurveysProgressIndexResponseTypes,
  ApisManagersEmployeeConditionSurveysProgressIndexRequestTypes,
} from "~/domains";

type QueryFnType = typeof request;
type PropsType = {
  employeeConditionSurveyId: string;
  params: ApisManagersEmployeeConditionSurveysProgressIndexRequestTypes;
  config?: QueryConfigType<QueryFnType>;
};

const request = ({
  employeeConditionSurveyId,
  params,
}: {
  employeeConditionSurveyId: string;
  params: ApisManagersEmployeeConditionSurveysProgressIndexRequestTypes;
}) => {
  return new ApiClient()
    .get<ApisManagersEmployeeConditionSurveysProgressIndexResponseTypes>(
      `/api/managers/employee_condition_surveys/${employeeConditionSurveyId}/progresses`,
      {
        params,
      },
    )
    .then((res) => res.data);
};

export const useApisManagersEmployeeConditionSurveysProgressIndex = ({
  params,
  employeeConditionSurveyId,
  config = {},
}: PropsType): UseQueryResult<ApisManagersEmployeeConditionSurveysProgressIndexResponseTypes> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisManagersEmployeeConditionSurveysProgressIndex",
      employeeConditionSurveyId,
      params,
    ],
    queryFn: () => request({ employeeConditionSurveyId, params }),
  });
};
